import SpotifyPlayer from './SpotifyPlayer';
import React, { useRef } from 'react';
import {QRCodeSVG} from 'qrcode.react';
import './Card.scss'
import CountryFlags from './CountryFlags.json';
import CountryCodes from './CountryMap.json';

import LOCATIONS from './LocationsMap.json';


const reverseCodes = {}
Object.keys(CountryCodes).forEach(key => {
    reverseCodes[CountryCodes[key]] = key
})
console.log(reverseCodes)

function Card({accessToken, song, scale, side, print}) {
  const cardRef = useRef(null);

  const handleClick = () => {
    if (cardRef.current) {
      cardRef.current.classList.toggle('flipped');
    }
  };

    const playerRef = useRef();

  const songLocation = btoa(song.year + "/" + song.country)

  return (
    <div style={{transform:`scale(${scale || 1})`, transformOrigin: 'top left'}} onClick={print ? undefined : handleClick}>
      <div className={`flip-card ${side === 'back' ? 'flipped' : ''}`} id="flipCard" ref={cardRef}>
        <div className="flip-card-inner">
          <div className={`flip-card-front quad ${print ? 'quad-4' : 'quad-3'}`}>
            { accessToken ? (
                <div className="play-button">
                    <div className="play-icon">
                        <SpotifyPlayer ref={playerRef}  accessToken={accessToken} trackUri={`spotify:track:${song.spotify}`} />
                    </div>
                </div>
            ) : (
                <QRCodeSVG
                    fgColor="#000"
                    bgColor={print ? "#fff" : "#fff0cc"}
                    height={256}
                    width={256}
                    value={`https://app.songsort.eu/songs/${songLocation}`} />
                )
            }
          </div>
          <div className={`flip-card-back quad ${print ? 'quad-2' : 'quad-1'}`}>

            <div className="song-info">
                <img
                  src={CountryFlags[song.country]}
                  className="country-flag" alt="" />
                <p className="song-country">{reverseCodes[song.country]}</p>
                <p className="song-artist">{song.artist}</p>
                <p className="song-title">{song.song}</p>
            </div>
            <div style={{
               height: '100%',
               flexWrap: 'wrap',
               alignContent: 'flex-start',  // <-- This forces rows to pack at the top with no gaps
               alignItems: 'flex-start',
               gap: 0,          // explicitly remove gap between flex items
               rowGap: 0,       // explicitly remove vertical gap between rows
               margin: 0,       // remove margin if any from children
               padding: 0,
             }} >
                <div className="new-card-side">
                    <p className="new-song-year">{song.year}</p>
                    <p className="song-place">{!isNaN(song.place) ? song.place + "." : song.place}</p>
                </div>
                <p className="song-location">{`${LOCATIONS[song.year].city}, ${LOCATIONS[song.year].country}`}</p>
             </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Card;